import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Debug: Log immediately when script loads AND set window property
console.log('[INDEX] Script loaded at', new Date().toISOString());
console.log('[INDEX] React version:', React.version);
console.log('[INDEX] About to render App component');
// Set window property to verify code is running
(window as any).__CSIPAY_AI_LOADED__ = new Date().toISOString();
console.log('[INDEX] Window property set:', (window as any).__CSIPAY_AI_LOADED__);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 